import React, { useContext, useEffect, useState } from 'react';
import './Notifications.css';

import Helmet from '../../component/Helmet/Helmet';
import Sidebar from '../../component/layouts/Sidebar';
import MobileTopBar from '../../component/layouts/MobileTopBar';
import RightSide from '../../component/layouts/rightSide';
import { AppContext } from '../../context/AppContext';

const Notifications = () => {

    const {user,token} = useContext(AppContext);

    const [notifications, setNotifications] = useState([]);


    async function getNotifications() {

          const res = await fetch('https://dashboard.tiktaka.com/api/notifications',{
          headers: {
            Authorization: `Bearer ${token}`,  
          },
    });

    const data = await res.json();


     if(res.ok){
        setNotifications(data.notifications);
        // console.log('====================================');
        // console.log(data.notifications);
        // console.log('====================================');
        // console.log(1111);
        
    }
    }

      useEffect( ()=>{
        getNotifications();
      },[]);

  return (
  <Helmet title='Notifications'>
    <div className="Notifications">
    
    <Sidebar/>

    <div className='midSide'>
    <div className='middleSideHome'>
     
     <MobileTopBar/>
      
      {/* Start Main Section */}

        <div className='mainSection'>
           {/* <h2>Notifications Page</h2> */}

             <div class="notification-center">
      

              

              {
                notifications.length === 0 ? 
              (  <div class="empty" id="empty-state">
                  <p>No new notifications 🚀</p>
                </div>) : 

                
                  notifications.map( (notification) => (

                    (<div class="notifications" id="notif-list">

                        <div className='notification'>
                              <div className='userNameRightSide' style={{ marginBottom:'10px' }}>{notification.data.message}</div>
                              <div className='userFullName'>{notification.data.sub_message}
                              <div className='userFullName' style={{ float: 'right' }}>{ new Date(notification.created_at).toLocaleString()}</div>

                              </div>
                      </div>
                        
                  </div>)

                   ) )
                

              }

              <div class="footer">
                <button id="mark-all">Mark All Read</button>
                <button id="clear-all">Clear All</button>
              </div>
            </div>
        </div>
    </div>
    </div>
   
   <RightSide/>

  </div>
  </Helmet>
  );
};

export default Notifications;